import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MagicParticles',
    props: {
        count: { default: 30 },
        zIndex: { default: 2 },
        containerClass: { default: '' }
    },
    setup(__props) {
        const props = __props;
        // ============================================
        // 粒子样式生成
        // ============================================
        const particleStyles = computed(() => {
            return Array.from({ length: props.count }, () => {
                return {
                    '--p-left': `${Math.random() * 100}%`,
                    '--p-delay': `${Math.random() * 5}s`,
                    '--p-duration': `${3 + Math.random() * 4}s`,
                    '--p-size': `${1 + Math.random() * 4}px`,
                };
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["isekai-magic-particles", __props.containerClass]),
                style: _normalizeStyle({
                    zIndex: String(__props.zIndex),
                })
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(particleStyles.value, (style, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "isekai-magic-particles__particle",
                        style: _normalizeStyle(style)
                    }, null, 4 /* STYLE */));
                }), 128 /* KEYED_FRAGMENT */))
            ], 6 /* CLASS, STYLE */));
        };
    }
});
